import {debounce} from '../utils/debounce'
import {Chart, LinearScale, LineElement, LineController, PointElement, TimeSeriesScale, Title, Tooltip} from 'chart.js'
import 'chartjs-adapter-luxon'
import DateTime from 'luxon/src/datetime.js'
import {PercentFormat} from 'utils/percent_format'

Chart.register(LinearScale, LineElement, LineController, PointElement, TimeSeriesScale, Title, Tooltip)

export class OptimizedYieldGraph

  constructor: ->
    @renderGraph() if @canvas() and @canvas().dataset.id

  renderGraph: ->
    @id = @canvas().dataset.id
    @downloadAndDrawChart()

  downloadAndDrawChart: ->
    fetch("/shares/#{@id}/history.json").then (response) => @receiveResponse(response)

  receiveResponse: (response) ->
    response.json().then (data) =>
      @data = data
      if @data.dates and @data.dates.length > 1
        @drawChart()
      else
        @dataUnavailable()

  dataUnavailable: ->
    p = document.createElement('p')
    p.classList.add '.mdc-typography--body1'
    p.innerText = "Sorry, this graph is currently not available"
    @canvas().classList.add('error')
    @canvas().innerHTML = p

  canvas: -> document.querySelector('canvas#optimizer-graph')

  graphLabels: ->
    @data.dates.map (date) -> DateTime.fromObject(year: date[0], month: date[1], day: date[2], zone: 'utc')

  drawChart: ->
    new Chart(@canvas(), @graphOptions())

  graphOptions: ->
    unit = @data.unit

    type: 'line'
    data: {
      labels: @data.dates
      datasets: [{
        label: "Share Price (#{@data.unit})"
        data: @data.prices
        backgroundColor: "rgba(93,23,240,1)"
        borderColor: "rgba(37,50,215,1)"
        pointRadius: 0
        fill: false
        yAxisID: 'y'
      },{
        label: "Optimized Yield (%)"
        data: @data.yields
        pointRadius: 0
        backgroundColor: "rgba(72,193,240,1)"
        borderColor: "rgba(37,164,215,1)"
        fill: false
        yAxisID: 'y1'
      }]
    },
    options:
      responsive: true
      maintainAspectRatio: false
      interaction:
        mode: 'index'
        position: 'average'
        intersect: false
      plugins:
        tooltip:
          callbacks:
            label: (context) ->
              if context.datasetIndex is 1
                return "Optimized Yield: #{PercentFormat.format context.parsed.y}"
              else
                return "Share Price: #{context.parsed.y}#{unit}"
      scales:
        x:
          type: 'time'
          time:
            unit: 'month'
            tooltipFormat: 'DD'
        y:
          type: 'linear'
          position: 'right'
          min: 0
          scaleLabel:
            display: true
            labelString: "Share Price (#{@data.unit})"
          ticks:
            beginAtZero: true
        y1:
          type: 'linear'
          position: 'left'
          min: 0
          scaleLabel:
            display: true
            labelString: "Optimized Yield (%)"
          ticks:
            beginAtZero: true